'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minutesAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/minutesAfter.js
// module id = 709
// module chunks = 0